/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_WeighingsInputs */

const vi_nav_weighings = /** @type {(inputs: Nav_WeighingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cân chè tươi`)
};

/**

* @param {Nav_WeighingsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_weighings = /** @type {((inputs?: Nav_WeighingsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_WeighingsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_weighings(inputs)
});